import React from 'react';
import './services.css';
import 'bootstrap/dist/css/bootstrap.min.css';
class Services extends React.Component{


  render(){
    return(
      <div id="services">
          <div className="container">
           <h2 className="h1-responsive font-weight-bold text-center my-4"><i className="fa  fa-wrench"> </i> Services</h2>
            <div className="row">
                <div className="col-sm-4 col-xs-12" id="service1">
                    <h3> <span className="fa fa-television"></span> Web App</h3>
                    <p>
                    We've been building websites for almost 2 years, and we we've done so with a plethora of technoloqies, 
                    from legacy to shiny new ones. We can design, build and ship web platforms tailored to your needs. 
                    </p>
                </div>

                <div className="col-sm-3 col-xs-12" id="service2">
                    <h3><span className="fa fa-tasks"></span> Web Hosting</h3>
                    <p>
                    Publishing your digital product to the public is mandory for people to use it. We can help host your websites, web apps and/or services. 
                    Ranging from using CDNs to caching, performance is at the heart of what we do.  
                    </p>
                </div>

                <div className=" col-sm-4 col-xs-12" id="service3">
                    <h3><span className="fa fa-briefcase"></span> Domain Name</h3>
                    <p>
                    Registering a domain name is the first step to your startup. 
                    Keep it short, sweet and marketable. We know the best places to buy and manage yours. 
                    </p>
                </div>
            </div> 
          </div>
      </div>
    
    
    )  
  }
}

export default Services;
